import { times } from 'lodash';

import {
  ADVANCED_SEARCH_FORM_ROW_COUNT,
  BOOLEAN_CHIP,
  defaultAdvancedSearchRowState,
  FormValues,
} from '../constants';

export const getFormValuesObject = (
  rowCount = ADVANCED_SEARCH_FORM_ROW_COUNT
): FormValues => {
  const rows = {};

  times(rowCount, index => {
    rows[index] = {
      ...defaultAdvancedSearchRowState,
      ...(index > 0 && { booleanChip: BOOLEAN_CHIP.and }),
    };
  });

  return rows;
};
